import React, { useState, useEffect, useCallback } from 'react'
import { Grid, Button, Checkbox, TextField, Collapse, Typography, Card, CardHeader, CardContent, Divider, IconButton } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import { ButtonWithLoading } from 'components/ButtonWithLoading'
import { useFormState } from 'hooks/useFormState'
import { SelecionarData } from 'components'
import { useRequisicaoService } from 'hooks/useRequisicaoService'
import { SelectSetor } from 'components/SelectSetor'
import { SelectOrgao } from 'components/SelectOrgao'
import { SelectUsuarios } from 'components/SelectUsuarios'
import { SelectStatusReq } from 'components/SelectStatusReq'
import useStyles from './styles'

export const Filtros = (props) => {
  const { setRequisicoes, setProcessandoRequisicao } = props
  const classes = useStyles()
  const requisicaoService = useRequisicaoService()
  const [open, setOpen] = useState(false)
  const [processandoOptions, setProcessandoOptions] = useState(false)

  const [filtroUsuarioRequisitante, setFiltroUsuarioRequisitante] = useState([])
  const [filtroOrgaoOrigem, setFiltroOrgaoOrigem] = useState([])
  const [filtroSetorSolicitante, setFiltroSetorSolicitante] = useState([])
  const [filtroSetorDestino, setFiltroSetorDestino] = useState([])
  const [filtroStatusRequisicao, setFiltroStatusRequisicao] = useState('')

  const formFiltroRequisicao = useFormState(
    {},
    {
      search: '',
      identificadorCasoRip: '',
      statusRequisicao: '',
      nic: '',
      dataCadastroInicio: new Date(),
      dataCadastroFinal: new Date(),
      dataCadastroChecked: false,
      autoridadeRequisitante: [],
      setorSolicitante: [],
      setorDestino: [],
      orgaoOrigem: [],
    }
  )

  const fetchRequisicoesPorSetores = async () => {
    const response = await requisicaoService.listarRequisicoesPorSetores(setProcessandoRequisicao)
    setRequisicoes(response)
  }

  const filtrarRequisicao = useCallback(async () => {
    const response = await requisicaoService.listarRequisicoesFiltradosAsync(formFiltroRequisicao.formState.values, setProcessandoRequisicao)
    setRequisicoes(response)
    setOpen(false)
  }, [formFiltroRequisicao.formState.values])

  const handleOpenFiltro = () => {
    setOpen(!open)
  }

  const handleLimparFiltros = useCallback(async () => {
    setFiltroUsuarioRequisitante([])
    setFiltroOrgaoOrigem([])
    setFiltroSetorSolicitante([])
    setFiltroSetorDestino([])
    setFiltroStatusRequisicao('')
    formFiltroRequisicao.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        search: '',
        identificadorCasoRip: '',
        nic: '',
        statusRequisicao: '',
        dataCadastroInicio: new Date(),
        dataCadastroFinal: new Date(),
        dataCadastroChecked: false,
        autoridadeRequisitante: [],
        setorSolicitante: [],
        setorDestino: [],
        orgaoOrigem: [],
      },
    }))
  })

  // handleChange do formulário de filtro
  const handleChangeFiltroDataCadastroInicio = (valor) => {
    formFiltroRequisicao.handleChangeCampoData('dataCadastroInicio', valor)
  }
  const handleChangeFiltroDataCadastroFinal = (valor) => {
    formFiltroRequisicao.handleChangeCampoData('dataCadastroFinal', valor)
  }

  useEffect(() => {
    if (!formFiltroRequisicao.formState.values.dataCadastroInicio) {
      const dataAtual = new Date()
      dataAtual.setHours(0, 0, 0, 0)
      const dataDiaAnterior = new Date(dataAtual.getTime())
      dataDiaAnterior.setDate(dataAtual.getDate() - 1)
      formFiltroRequisicao.setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          dataEntradaInicio: dataDiaAnterior,
          dataEntradaFinal: dataAtual,
        },
      }))
    }
  }, [])

  useEffect(() => {
    fetchRequisicoesPorSetores()
  }, [])

  useEffect(() => {
    formFiltroRequisicao.handleChangeCampoData('autoridadeRequisitante', filtroUsuarioRequisitante)
    formFiltroRequisicao.handleChangeCampoData('setorDestino', filtroSetorDestino)
    formFiltroRequisicao.handleChangeCampoData('statusRequisicao', filtroStatusRequisicao)
    formFiltroRequisicao.handleChangeCampoData('setorSolicitante', filtroSetorSolicitante)
    formFiltroRequisicao.handleChangeCampoData('orgaoOrigem', filtroOrgaoOrigem)
  }, [filtroUsuarioRequisitante, filtroStatusRequisicao, filtroSetorDestino, filtroSetorSolicitante, filtroOrgaoOrigem])

  return (
    <Card className={classes.cardFiltros}>
      <CardHeader
        title={<Typography className={classes.cardTitle}>FILTROS</Typography>}
        action={
          <IconButton onClick={handleOpenFiltro} aria-expanded={open} size="small">
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        className={classes.cardHeader}
      />
      <Divider />
      <Collapse in={open}>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={3}>
            {/* Coluna 1: Atores da Requisição */}
            <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
              <Typography variant="subtitle2" className={classes.grupoTitle}>
                Atores da Requisição
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} className={classes.item}>
                  <SelectUsuarios usuariosExternos={filtroUsuarioRequisitante} setUsuariosExternos={setFiltroUsuarioRequisitante} setProcessando={setProcessandoOptions} label="AUTORIDADE REQUISITANTE" isFromBanco={true} multiplo={true} />
                </Grid>
                <Grid item xs={12} className={classes.item}>
                  <SelectOrgao orgaosExternos={filtroOrgaoOrigem} setOrgaosExternos={setFiltroOrgaoOrigem} setProcessando={setProcessandoOptions} label="ÓRGÃO DE ORIGEM" />
                </Grid>
                <Grid item xs={12} className={classes.item}>
                  <SelectSetor setoresExternos={filtroSetorSolicitante} setSetoresExternos={setFiltroSetorSolicitante} setProcessando={setProcessandoOptions} label="SETOR SOLICITANTE" />
                </Grid>
                <Grid item xs={12} className={classes.item}>
                  <SelectSetor setoresExternos={filtroSetorDestino} setSetoresExternos={setFiltroSetorDestino} setProcessando={setProcessandoOptions} label="SETOR DESTINO" />
                </Grid>
              </Grid>
            </Grid>

            {/* Coluna 2: Identificação */}
            <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
              <Typography variant="subtitle2" className={classes.grupoTitle}>
                Identificação
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} className={classes.field}>
                  <TextField
                    fullWidth
                    label="IDENTIFICADOR CASO RIP"
                    name="identificadorCasoRip"
                    onChange={formFiltroRequisicao.handleChange}
                    value={formFiltroRequisicao.formState.values.identificadorCasoRip}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <SelectStatusReq statusSelecionado={filtroStatusRequisicao} setStatusSelecionado={setFiltroStatusRequisicao} label="STATUS" />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <TextField
                    fullWidth
                    label="NIC"
                    name="nic"
                    onChange={formFiltroRequisicao.handleChange}
                    value={formFiltroRequisicao.formState.values.nic}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Coluna 3: Período de Cadastro */}
            <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
              <Typography variant="subtitle2" className={classes.grupoTitle}>
                Período de Cadastro
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} className={classes.itemData}>
                  <Grid alignItems="center" container spacing={1}>
                    <Grid item xs={2}>
                      <Checkbox checked={formFiltroRequisicao.formState.values.dataCadastroChecked || false} onChange={formFiltroRequisicao.handleChange} name="dataCadastroChecked" />
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="body2" color="textSecondary">
                        Filtrar por data de cadastro
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <SelecionarData
                    dataBD={formFiltroRequisicao.formState.values.dataCadastroInicio}
                    withoutTime
                    callback={handleChangeFiltroDataCadastroInicio}
                    label="Data de Cadastro - Início"
                    disabled={!formFiltroRequisicao.formState.values.dataCadastroChecked}
                    name="dataCadastroInicio"
                    maxDate={formFiltroRequisicao.formState.values.dataCadastroFinal}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <SelecionarData
                    dataBD={formFiltroRequisicao.formState.values.dataCadastroFinal}
                    withoutTime
                    callback={handleChangeFiltroDataCadastroFinal}
                    label="Data de Cadastro - Final"
                    disabled={!formFiltroRequisicao.formState.values.dataCadastroChecked}
                    name="dataCadastroFinal"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className={classes.cardActions}>
            <Button onClick={handleLimparFiltros} startIcon={<ClearIcon />}>
              LIMPAR
            </Button>
            <Button className={classes.submitButton} variant="contained" onClick={filtrarRequisicao}>
              Filtrar
            </Button>
          </div>
        </CardContent>
      </Collapse>
    </Card>
  )
}
